import { createOpenOrderDrawerScanAction } from '../scan_actions/openOrderDrawer.action';
import { createRedirectAndOpenOrderDrawerScanAction } from '../scan_actions/redirectAndOpenOrderDrawer.action';
import { createSubmitOrderDetailsPageScanAction } from '../scan_actions/submitOrderDetailsPage.action';
import { createSubmitOrderDrawerScanAction } from '../scan_actions/submitOrderDrawer.action';
import { type ScanAction } from '../types/scanAction.type';

/**
 * Scan action candidates in order of hierarchy.
 * Resolution takes the first match, so a higher entry wins over every entry below it.
 */
export const SCAN_ACTIONS: readonly ScanAction[] = [
  createOpenOrderDrawerScanAction(),
  createRedirectAndOpenOrderDrawerScanAction(),
  createSubmitOrderDrawerScanAction(),
  createSubmitOrderDetailsPageScanAction(),
];
